import React from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { AUDIT_BMSF } from '../../../Utils/Constants';

const auditTableBMSF = [
    { id: 'RequestDate', label: 'DATA' },
    { id: 'Request', label: 'REQUEST' },
    { id: 'Response', label: 'RESPONSE' },
];

const auditTableSFBM = [
    { id: 'ServiceName', label: 'NOME SERVIÇO' },
    { id: 'RequestDate', label: 'DATA' },
    { id: 'Request', label: 'REQUEST' },
    { id: 'Response', label: 'RESPONSE' },
];

const styles = ({
  tblHead: {
    backgroundColor: '#A5A5A5'
  },
  tblHeadT: {
    color: '#ffffff',
    fontSize: '14px'
  },
  tblBorder: {
    border: '2px solid #ffffff'
  },
  headerHeight: {
    height: '40px'
  },
  textCenter: {
    textAlign: 'center'
  },
  cellPadding: {
    paddingLeft: '16px'
  },
  tblSort: {
    height: '12px',
    width: '12px',
    margin: '0px 2px'
  }
});


class AdminSalesForceSyncTableHeader extends React.Component {

  render() {
    const { classes } = this.props;
    return (
      <TableHead className={classes.tblHead} >
        <TableRow className={classes.headerHeight} >
            {this.props.tableList.indexOf(AUDIT_BMSF) > -1 ?
                auditTableBMSF.map(column => {
                    return (
                    <TableCell
                        key={column.id}
                        padding='none'
                        className={classNames(classes.tblHeadT, classes.tblBorder, classes.textCenter, classes.cellPadding)}
                    >
                        <TableSortLabel
                        className={classes.tblHeadT}
                        classes={{ icon: classes.tblSort }}
                        >
                        {column.label}
                        </TableSortLabel>
                    </TableCell>
                    );
                }, this)
            :
                auditTableSFBM.map(column => {
                    return (
                    <TableCell
                        key={column.id}
                        padding='none'
                        className={classNames(classes.tblHeadT, classes.tblBorder, classes.textCenter, classes.cellPadding)}
                    >
                        <TableSortLabel
                        className={classes.tblHeadT}
                        classes={{ icon: classes.tblSort }}
                        >
                        {column.label}
                        </TableSortLabel>
                    </TableCell>
                    );
                }, this)
            }
        </TableRow>
      </TableHead>
    );
  }
}

AdminSalesForceSyncTableHeader.propTypes = {
};

export default AdminSalesForceSyncTableHeader = withStyles(styles)(AdminSalesForceSyncTableHeader);


// WEBPACK FOOTER //
// ./src/components/Administration/AdminSalesForceAudit/AdminSalesForceAuditTableHeader.js